import $ from "cash-dom"
import lazy_loader from "../lazy_loader"
import init_embedded_quizzes from "../init/embedded_quizzes"
import {init_embedded_videos} from "../init/embedded_video"
import apply_new_badge_to_contentboxes from "../apply_new_badge_to_contentboxes"
import init_image_with_caption from "../init/image_with_caption"
import init_image_gallery from "../init/image_gallery"
import init_combined_image_gallery from "../init/combined_image_gallery"
import init_overview_images from "../init/overview_images"
import vimeo_manager from "../vimeo_manager"
import {Controller} from "@hotwired/stimulus"
import viewport_helper from "../viewport_helper"
import study_unit_tour from "../study_unit_tour"
import init_quiz_mode_selector_modal from "../init/quiz_mode_selector_modal"

class StudyUnitController extends Controller {
  static targets = ["suCompleteBox", "completionBox"]

  connect() {
    vimeo_manager.init()
    this.update_su_complete_box_height_css()
    init_embedded_videos()
    init_embedded_quizzes()
    apply_new_badge_to_contentboxes()
    this.start_su_tour()
    // These are the containers of images with captions, generated
    // by `enrich_with_figure_captions`.
    lazy_loader.add($("figure:not(.overview-image)"), init_image_with_caption)
    lazy_loader.add(
      $(".embedded-widget.image-gallery-container"),
      init_image_gallery
    )
    lazy_loader.add(
      $(".embedded-widget.combined-image-gallery"),
      init_combined_image_gallery
    )
    lazy_loader.add($(".overview-images-container"), init_overview_images)
  }

  disconnect() {
    this.tour_observer?.disconnect()
  }

  scroll_to_target() {
    if (!this.hasCompletionBoxTarget) return

    viewport_helper.go_to(this.completionBoxTarget)
  }

  async start_exam(event) {
    const quiz_slug = event.currentTarget.dataset.quizSlug
    await init_quiz_mode_selector_modal(
      quiz_slug,
      null,
      {initial_quiz_mode: "exam_mode", exam_conditions: true}
    )
  }

  update_su_complete_box_height_css() {
    if (!this.hasSuCompleteBoxTarget) return

    document.documentElement.style.setProperty("--su-complete-box-height",
      `${this.suCompleteBoxTarget.offsetHeight}px`)
  }

  start_su_tour() {
    if (window.location.hash === "#study_unit_tour") {
      return study_unit_tour(this)
    }

    if (!window.gon.current_user) return
    if (!window.gon.show_product_tours) return
    if (window.gon.completed_tours.includes("study_unit_tour")) return

    study_unit_tour(this)
  }
}

export default StudyUnitController
